<div class="avatar" [class.no-background]="noBackground" [ngClass]="avatarSize" [ngStyle]="{'backgroundImage': imageSrc, 'backgroundColor': bgColor}">
  <bw-icon-legacy [size]="iconSize" [iconName]="iconName" [color]="iconColor" *ngIf="!imageURL"></bw-icon-legacy>
</div>
